
import { Component, Mixins } from "vue-property-decorator";

@Component({
})
export default class SourcePrintableMixin extends Mixins() {
  data(): any {
    return {
      sourceToPrint: null,
    };
  }
  sourceToPrint: string;

  get pluginSourceToPrint(): string {
    return this.shouldShow
      ? this.sourceToPrint
      : "";
  }

  get shouldShow(): boolean {
    return !!this.sourceToPrint
      && (this.sourceToPrint !== "");
  }
}
